module.exports = __webpack_public_path__ + "static/media/MK 5 tmp.bd632afe.mp3";